import { component } from 'picoapp';
import Ready from '../../js/utils/ready';

export default component(async (node, ctx) => {
  /**
   * Data + elements
   */
  const diagrams = node.querySelectorAll('.js-diagram');

  /**
   * Functions
   */
  const init = () => {
    const update = (rect) => {
      const inView = rect.top <= window.innerHeight * 0.75;

      if (inView) {
        diagrams.forEach((diagram, index) => {
          setTimeout(() => {
            diagram.style.width = '100%';
          }, index * 300);
        });
      }
    };

    Ready(() => {
      update(node.getBoundingClientRect());

      ctx.on('window:scroll', () => {
        update(node.getBoundingClientRect());
      });
    });
  };

  /**
   * Init
   */
  init();
});
